import { useEffect } from "react";
import { formatDateAlt } from "../helpers/date";
import { FILTER_VALUE_ACTIVOS, FILTER_VALUE_FINALIZADOS } from "../const/filtersValue/filterValue";

// useTimeDifferenceInMinutes: Custom hook que permite calcular la diferencia
// entre la hora actual y la hora de llega del mensaje, y los retorna en minutos.

const useTimeDifferenceInMinutes = ({ chat, timeDifference, setTimeDifference }) => {

    useEffect(() => {     // Actualizar el tiempo transcurrido cada minuto.
        
        //Cuando el componenet se monta, se ejecuta el setTimeout cada segundo. 
        // Este temporizador se mantendrá activo mientras el componente esté montado.
        const timer = setTimeout(() => {
            //Resta la fecha actual de la fecha enviada del mensaje, y lo divide en 
            //60000 para convertir de milisegundo a minuto.
            const differenceInMinutes = Math.floor((new Date() - new Date(formatDateAlt(chat.FechaHora))) / 60000);
            /* console.log("VOY A VER ESTE CHAT AHORA", chat) */

            //Setea la diferencia de tiempo en minuto.
            setTimeDifference(differenceInMinutes);

        }, 60000); // Actualizar cada 1 minuto.

        return () => clearTimeout(timer);

    }, [chat.FechaHora, timeDifference, setTimeDifference]);

};

export default useTimeDifferenceInMinutes;